import React from "react";
import Check from "./Check";
import DashBoard from "./DashBoard";
import DashmiuBoard from "./DashmiuBoard";

import Jobs from "./Jobs";
import Studentnav from "./Studentnav";
export default function Stuhome() {
  
  return (
    <>
      <Studentnav/>
      <Jobs/>
      
      
    </>
  );
}
